export default [
  { title: 'Products', url: '/products' },
  { title: 'Experiences', url: '/experiences' },
  { title: 'Experiments', url: '/experiments' },
  { title: 'About', url: '/about' }
  // { title: 'Jobs', url: 'https://nextempire.homerun.co/', external: true }
]
